import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ImportToolbar = ({ onImport, onAutoMatch, onClearMatches, matchedCount, totalCount }) => {
  const [isImporting, setIsImporting] = useState(false);
  const [isMatching, setIsMatching] = useState(false);

  const handleImport = async (format) => {
    setIsImporting(true);
    await onImport(format);
    setIsImporting(false);
  };

  const handleAutoMatch = async () => {
    setIsMatching(true);
    await onAutoMatch();
    setIsMatching(false);
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center">
            <Icon name="Upload" size={20} color="var(--color-accent)" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-base md:text-lg">Import & Match</h3>
            <p className="caption text-muted-foreground">
              {matchedCount} of {totalCount} transactions matched
            </p>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleImport('ofx')}
            loading={isImporting}
            iconName="FileText"
            iconPosition="left"
          >
            Import OFX
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleImport('csv')}
            loading={isImporting}
            iconName="FileSpreadsheet"
            iconPosition="left"
          >
            Import CSV
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleAutoMatch}
            loading={isMatching}
            iconName="Zap"
            iconPosition="left"
          >
            Auto-Match
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearMatches}
            iconName="X"
            iconPosition="left"
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImportToolbar;